/* src/app/modules/members/member-summary/member-summary.component.css */
div.data-title {
  font-weight: bold;
  margin: 5px;
  margin-bottom: 0px;
  margin-top: 0px;
}
div.data {
  margin: 5px;
  margin-top: 0px;
  white-space: pre-line;
}
div.member-photo-holder img {
  border-radius: 100px;
  width: 50px;
  height: 50px;
  margin: 0px;
}
.media {
  cursor: pointer;
  width: 100%;
  margin: 10px 0;
}
.special {
  color: #d81e05;
}
/*# sourceMappingURL=member-summary.component.css.map */
